import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'Capabilities',
    href: '#about'
  }, {
    name: 'Approach',
    href: '#services'
  }, {
    name: 'Insights',
    href: '#why-deploid'
  }, {
    name: 'Contact Us',
    href: '#contact'
  }];
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-deep-navy/90 backdrop-blur-xl py-3 border-b border-deploid-purple/30 shadow-[0_0_30px_rgba(79,12,154,0.2)]' : 'bg-transparent py-6'}`} initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-310">
      <div className="container mx-auto px-4 md:px-6 flex justify-end items-center relative z-10" data-id="element-311">
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-312">
          {navItems.map((item, index) => <motion.a key={item.name} href={item.href} className="text-white/80 text-sm hover:text-electric-yellow transition-all duration-300 relative group" initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} whileHover={{
          y: -2
        }} data-id="element-313">
              {item.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-electric-yellow group-hover:w-full transition-all duration-300" data-id="element-314" />
            </motion.a>)}
        </nav>

        {/* Mobile Menu Button */}
        <motion.button className="md:hidden text-white relative p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} whileTap={{
        scale: 0.95
      }} data-id="element-315">
          <div className="absolute inset-0 bg-deploid-purple/20 rounded-sm opacity-0 hover:opacity-100 transition-opacity" data-id="element-316" />
          {isMobileMenuOpen ? <XIcon size={24} className="text-white relative z-10" data-id="element-317" /> : <MenuIcon size={24} className="text-white relative z-10" data-id="element-318" />}
        </motion.button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-319">
        {isMobileMenuOpen && <motion.div className="md:hidden absolute top-full left-0 right-0 bg-deep-navy/95 backdrop-blur-xl border-b border-deploid-purple/30" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-320">
            <div className="container mx-auto px-4 py-6 flex flex-col space-y-4" data-id="element-321">
              {navItems.map((item, index) => <motion.a key={item.name} href={item.href} className="text-white/80 text-sm py-3 hover:text-electric-yellow transition-colors border-b border-deploid-purple/20" onClick={() => setIsMobileMenuOpen(false)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.2,
            delay: index * 0.05
          }} whileHover={{
            x: 5
          }} data-id="element-322">
                  {item.name}
                </motion.a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
};